export const getRelativeRect = (base: DOMRect, rect: DOMRect): DOMRect => new DOMRect(rect.left - base.left, rect.top - base.top, rect.width, rect.height);
